export default __webpack_public_path__ + "static/property-img-3_1600-05f3fbb311801a0990dc189eb9705a4b.jpg";